import { render, staticRenderFns } from "./TradeRelatedProducts.vue?vue&type=template&id=27d435a0&"
import script from "./TradeRelatedProducts.vue?vue&type=script&lang=js&"
export * from "./TradeRelatedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports